import * as React from 'react'
import styled from 'styled-components'

import Colors from '../../../stories/theme/colors'

const DuplicatedJobStyle = (component: React.ComponentType<any>): React.ComponentType<any> => styled(component)`
&.flash-message {
  display: flex;
  background: ${Colors.Primary.yellow400};
  height: 90px;
  justify-content: center;
  width: 100%;
  &__inner {
    align-self: center;
    display: flex;
    font-size: 1.1875rem;
    font-weight: normal;
    width: 800px;
  }
  &__icon {
    margin-right: 20px;
  }
}
`

export default DuplicatedJobStyle